import React from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import HomeIcon from "@mui/icons-material/Home";

export default function Contact() {
  return (
    <Box component="main" sx={{ py: 8 }}>
      <Container maxWidth="sm">
        <Stack spacing={3}>
          <Typography variant="h4" fontWeight={800}>
            Contact Us — FentrixBank
          </Typography>

          <Typography>
            We're here to help. Choose one of the contact options below and our team
            will get back to you as soon as possible.
          </Typography>

          <List>
            <ListItem>
              <ListItemIcon>
                <EmailIcon />
              </ListItemIcon>
              <ListItemText primary="Email" secondary="support@fentrixbank.com" />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <PhoneIcon />
              </ListItemIcon>
              <ListItemText primary="Phone" secondary="+1 (000) 000-0000" />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="Address" secondary="Virtual Financial HQ" />
            </ListItem>
          </List>

          <Box>
            <Typography variant="body2" color="text.secondary">
              For urgent security matters, please call the phone number above and
              mention "Security — Urgent".
            </Typography>

            <Button variant="contained" sx={{ mt: 2 }} href="/support">
              Open a Support Ticket
            </Button>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}